<template lang="pug">
  div
    .placeholder(v-if='loading')
    .content.year(v-if='!loading')
      .grid
        .col-3.titles
          router-link(:to={path: '/exhibitions'})
            h2
              | exhibitions
          h4.status
            | {{ $route.params.year }}
        .col-9_xs-12
          .grid.no-margin(v-if="exhibitions.length > 0")
            .col-6_xs-12(v-for="exhibition in exhibitions")
              router-link(:to="{path: year(exhibition.content.start_date) + '/' + exhibition.uid}")
                .screen-small
                  visual(
                    :image="exhibition.image"
                    background="cover"
                    role="img"
                    :aria-label="exhibition.content.title"
                  )
                  .captions
                    h1.title
                      | {{ exhibition.content.title }}
                    h2.dates
                      | {{ startDate(exhibition.content.start_date) }} - {{ endDate(exhibition.content.end_date) }}
          .grid.no-margin(v-else)
            .col-9_xs-12
              h2.standin
                | Traveling exhibitions coming soon ...
</template>

<script>
import DataMixin from '@/mixins/DataMixin'
import ComponentMixin from '@/mixins/ComponentMixin'
import dateFormat from 'dateformat'

export default {
  name: 'exhibitions-traveling',
  mixins: [DataMixin, ComponentMixin],

  data () {
    return {
      loading: false,
      loadedData: [],
      // url: 'http://localhost:8888/caam/caam_live/api/exhibitions-traveling/'
      url: 'https://caamuseum.org/api/exhibitions-traveling/'
    }
  },

  created () {
    this.key = 'traveling'
    this.getData()
  },

  methods: {
    getData: function () {
      this.loading = true
      this.get(this.url, response => {
        this.loading = false
        this.loadedData = response.data
      })
    },

    hero: function (image, files) {
      return files.find(item => item.filename === image)
    },

    startDate: function (date) {
      if (date) {
        const d = new Date(date)
        return dateFormat(d, 'mmmm d')
      } else {
        return ''
      }
    },

    endDate: function (date) {
      if (date) {
        const d = new Date(date)
        return dateFormat(d, 'mmmm d, yyyy')
      } else {
        return ''
      }
    },

    year: function (date) {
      if (date) {
        const d = new Date(date)
        return dateFormat(d, 'yyyy')
      } else {
        return ''
      }
    }
  },

  computed: {
    exhibitions: function () {
      return this.loadedData[this.key]
    },

    parameter: function () {
      return this.$route.params.year
    }
  }
}
</script>

<style lang="sass">
  @import '../styles/main'
  .content
    &.year
      .titles
        h2, h4
          padding-left: 0
      .status
        color: #FD0000
        font-size: 2rem
      .screen-small
        width: 100%
        height: 0
        padding-bottom: 100%
        position: relative
        .vv-image
          width: 100%
          height: 0
          padding-bottom: 100%
          background-repeat: no-repeat
          background-size: cover
        &:hover > .captions
          opacity: 1
          @include transition(opacity, 0.2s, ease-in-out)
        .captions
          width: 100%
          height: 100%
          background-color: rgba(255, 255, 255, 0.9)
          opacity: 0
          position: absolute
          bottom: 0
          @include transition(opacity, 0.2s, ease-in-out)
          h1
            position: absolute
            bottom: 0
            font-size: 4rem
            padding-left: 3.3rem
            padding-bottom: 7rem
            letter-spacing: $kerningTight
            line-height: 95%
          h2
            position: absolute
            bottom: 0
            font-size: 2.5rem
            padding-left: 3.3rem
            padding-bottom: 3.3rem
            letter-spacing: $kerningMidTight
    .standin
      margin-top: 14rem
</style>



// WEBPACK FOOTER //
// ExhibitionsTraveling.vue?443cd24a